import { DoodleIcon } from "../DoodleIcon";
import { useScrollAnimation } from "../../hooks/useScrollAnimation";
import { sectionArtwork } from '../../data/courseSectionVisuals';
import { CourseSectionArtwork } from './CourseSectionArtwork';

export const AboutCourseSection = ({ aboutSection }) => {
  const [sectionRef, isVisible] = useScrollAnimation({ threshold: 0.15 });
  const audience = aboutSection?.targetAudience || [];

  if (!audience.length) return null;

  return (
    <section 
      ref={sectionRef}
      className="py-20 bg-gradient-to-b from-white to-gray-50" 
      data-testid="about-course-section"
    >
      <div className="max-w-6xl mx-auto px-6">
        <div className={`text-center mb-12 transition-all duration-300 ease-out ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}>
          <span className="course-eyebrow">
            Для кого
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
            <span className="ink-underline">Кому подойдёт этот курс</span>
          </h2>
        </div>

        <div className="course-audience-layout">
        <CourseSectionArtwork art={sectionArtwork.audience} />
        <div className="course-audience-notes grid gap-6">
          {audience.map((item, index) => {

            
            return (
              <div 
                key={index}
                className={`bg-white rounded-2xl p-6 shadow-lg shadow-gray-200/50 border border-gray-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 ease-out ${
                  isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
                }`}
                style={{ transitionDelay: `${index * 100 + 200}ms` }}
              >
                <h3 className="text-gray-900 text-lg font-bold mb-2">{item.title}</h3>
                <p className="text-gray-500 text-sm mb-4">{item.description}</p>
                <div className="space-y-2">
                  {(item.benefits || []).map((benefit, idx) => (
                    <div key={idx} className="flex items-center gap-2 text-sm text-gray-600">
                      <DoodleIcon name="tick" size={18} />
                      <span>{benefit}</span>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
        </div>
      </div>
    </section>
  );
};
